import { fetchUtils } from 'react-admin'
import postgrestClient from './aor-postgrest-client.js'
import ac from './authClient.js'
import API_ROOT from './api-root'
import { 
  getSQLTemplate,
  updatePassword,
  insertAPIKey
 } from './overrides.js'

function httpClient (url, options) {
  if (!options.headers) {
    options.headers = new Headers({ Accept: 'application/json' })
  }
  const token = localStorage.getItem('token')
  if (token) {
    options.headers.set('Authorization', 'Bearer ' + token)
  }
  return fetchUtils.fetchJson(url, options)
}

// export API_ROOT from './api-root'

const authClient = ac

const restClient = postgrestClient(`${API_ROOT}`, httpClient)

const restClientWithOverrides = {
  ...restClient,
  getSQLTemplate,
  updatePassword,
  insertAPIKey
}
function rpcClient (url, options) {
  options.method = 'POST'
  return httpClient(`${API_ROOT}/rpc/${url}`, options)
}

export {
  rpcClient,
  authClient,
  restClientWithOverrides,
  restClient,
  httpClient,
  API_ROOT
}
